// Some convenience methods for measurement tools

/**
 * Format area (3 significant digits)
 */

export const formatArea = (area: number) => {
  let output: string
  if (area >= 100000000) { // >= 100 km2
    output = (area / 1000000).toFixed() + ' km²' // e.g. 123 km²
  } else if (area >= 10000000) { // >= 10 km2
    output = (area / 1000000).toFixed(1) + ' km²' // e.g. 12.3 km²
  } else if (area >= 1000000) { // >= 100 ha
    output = (area / 10000).toFixed() + ' ha' // e.g. 123 ha
  } else if (area >= 100000) { // >= 10 ha
    output = (area / 10000).toFixed(1) + ' ha' // e.g. 12.3 ha
  } else if (area >= 10000) { // >= 1 ha
    output = (area / 10000).toFixed(2) + ' ha' // e.g. 1.23 ha
  } else if (area >= 100) { // >= 100 m2
    output = area.toFixed() + ' m²' // e.g. 123 m²
  } else if (area >= 10) { // >= 10 m2
    output = area.toFixed(1) + ' m²' // e.g. 12.3 m²
  } else if (area >= 1) { // >= 1 m2
    output = area.toFixed(2) + ' m²' // e.g. 1.23 m²
  } else { // < 1 m2
    output = area.toFixed(2) + ' m²' // e.g. 0.12 m²
  }

  return output
}

/**
 * Format length (3 significant digits)
 */

export const formatLength = (length: number) => {
  let output: string
  if (length >= 100000) { // >= 100 km
    output = (length / 1000).toFixed() + ' km' // e.g. 123 km
  } else if (length >= 10000) { // >= 10 km
    output = (length / 1000).toFixed(1) + ' km' // e.g. 12.3 km
  } else if (length >= 1000) { // >= 1 km
    output = (length / 1000).toFixed(2) + ' km' // e.g. 1.23 km
  } else if (length >= 100) { // >= 100 m
    output = length.toFixed() + ' m' // e.g. 123 m
  } else if (length >= 10) { // >= 10 m
    output = length.toFixed(1) + ' m' // e.g. 12.3 m
  } else if (length >= 1) { // >= 1 m
    output = length.toFixed(2) + ' m' // e.g. 1.23 m
  } else if (length >= 0.1) { // >= 10 cm
    output = length.toFixed(2) + ' m' // e.g. 0.12 m
  } else { // < 10 cm
    output = length.toFixed(2) + ' m' // e.g. 0.01 m
  }

  return output
}
